/**
 * These hooks re-implement the now removed useBlocker and usePrompt hooks in 'react-router-dom'.
 * Thanks for the idea @piecyk https://github.com/remix-run/react-router/issues/8139#issuecomment-953816315
 * Source: https://github.com/remix-run/react-router/commit/256cad70d3fd4500b1abcfea66f3ee622fb90874#diff-b60f1a2d4276b2a605c05e19816634111de2e8a4186fe9dd7de8e344b65ed4d3L344-L381
 */
import { useEffect } from "react";
import { useBlocker, type BlockerFunction } from "react-router-dom";

/**
 * Prompts the user with an Alert before they leave the current screen.
 *
 * @param  message
 * @param  when
 */
export function usePrompt(
  message: string | undefined,
  when: boolean | BlockerFunction = true,
  options?: {
    onApprove?: () => void;
  }
) {
  const blocker = useBlocker(when);

  useEffect(() => {
    if (blocker.state === "blocked") {
      if (window.confirm(message)) {
        options?.onApprove?.();
        blocker.proceed();
      }
    }
  }, [blocker, message]);
}
